const routes = {
    register:'/auth/register',
    login:'/auth/login',
   

  };
  
  export default routes